;(function () {
  'use strict';

  function initCarousel(section) {
    if (section._feedatyCarousel) return;

    var screen = section.querySelector('.fdt_carousel__screen') ||
                 section.querySelector('.fdt_rev_block');
    var track = section.querySelector('.fdt_carousel__track');
    if (!screen || !track) return;

    var items = track.querySelectorAll('.fdt_carousel__item');
    if (!items.length) return;

    var perView = window.innerWidth < 750 ? 1 : 3;
    var current = 0;
    var total = items.length;
    var maxIndex = Math.max(0, total - perView);

    var prevBtn = section.querySelector('.feedaty-carousel__arrow--prev');
    var nextBtn = section.querySelector('.feedaty-carousel__arrow--next');

    function update() {
      var screenW = screen.getBoundingClientRect().width;
      var itemW = (screenW - gap * (perView - 1)) / perView;
      var offset = current * (itemW + gap);
      track.style.transform = 'translateX(-' + offset + 'px)';
      if (prevBtn) prevBtn.classList.toggle('feedaty-carousel__arrow--disabled', current <= 0);
      if (nextBtn) nextBtn.classList.toggle('feedaty-carousel__arrow--disabled', current >= maxIndex);
    }

    function recalc() {
      perView = window.innerWidth < 750 ? 1 : 3;
      maxIndex = Math.max(0, total - perView);
      if (current > maxIndex) current = maxIndex;
      update();
    }

    var gap = 16;
    screen.style.overflow = 'hidden';
    track.style.display = 'flex';
    track.style.transition = 'transform 0.4s ease';
    track.style.gap = '0';

    function setItemWidths() {
      var screenW = screen.getBoundingClientRect().width;
      var itemW = (screenW - gap * (perView - 1)) / perView;
      items.forEach(function (item) {
        item.style.setProperty('flex', '0 0 ' + itemW + 'px', 'important');
        item.style.setProperty('max-width', itemW + 'px', 'important');
        item.style.setProperty('width', itemW + 'px', 'important');
        item.style.setProperty('margin-right', gap + 'px', 'important');
        item.style.setProperty('box-sizing', 'border-box', 'important');
        item.style.setProperty('min-width', '0', 'important');
      });
    }
    setItemWidths();

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (current > 0) { current--; update(); }
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (current < maxIndex) { current++; update(); }
      });
    }

    update();
    section._feedatyCarousel = true;
    section.classList.add('feedaty-carousel--active');

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        setItemWidths();
        recalc();
      }, 150);
    });
  }

  function observeWidget(section) {
    var reviewsEl = section.querySelector('.feedaty-carousel__reviews');
    if (!reviewsEl) return;

    function tryInit() {
      var screen = section.querySelector('.fdt_carousel__screen') ||
                   section.querySelector('.fdt_rev_block');
      var track = section.querySelector('.fdt_carousel__track');
      if (screen && track && track.querySelectorAll('.fdt_carousel__item').length) {
        initCarousel(section);
        return true;
      }
      return false;
    }

    if (tryInit()) return;

    var observer = new MutationObserver(function () {
      if (tryInit()) observer.disconnect();
    });

    observer.observe(reviewsEl, { childList: true, subtree: true });
    setTimeout(function () { if (!tryInit()) observer.disconnect(); }, 6000);
  }

  function initAll() {
    document.querySelectorAll('.feedaty-carousel').forEach(observeWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
